import flatpickr from 'flatpickr';
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

export default () => {
  // 日付入力でのInputマスクの読み込み
  $('[data-mask]').inputmask();

  // datetime picker
  flatpickr('.flatpickr-datetime-sec', {
    enableTime: true,
    dateFormat: 'Y/m/d H:i:S',
    defaultHour: 0,
    minuteIncrement: 1,
    enableSeconds: true,
    locale: Japanese,
    disableMobile: 'true',
  });
  flatpickr('.flatpickr-datetime-future', {
    enableTime: true,
    dateFormat: 'Y/m/d H:i',
    defaultHour: 0,
    minuteIncrement: 1,
    locale: Japanese,
    minDate: 'today',
  });
  flatpickr('.flatpickr-date', {
    dateFormat: 'Y/m/d',
    locale: Japanese,
  });
  const maxDate = new Date();
  const aMonthAgo = maxDate.setMonth(maxDate.getMonth() - 1);
  flatpickr('.flatpickr-month', {
    altInput: true,
    locale: Japanese,
    maxDate: aMonthAgo,
    plugins: [
      new MonthSelectPlugin({
        shorthand: false,
        altFormat: 'Y年 M',
        dateFormat: 'Y/m',
      }),
    ],
  });

  const flatpickrDatetimeConfig = {
    enableTime: true,
    dateFormat: 'Y/m/d H:i',
    defaultHour: 0,
    minuteIncrement: 1,
    locale: Japanese,
  };

  flatpickr('.flatpickr-datetime', flatpickrDatetimeConfig);

  // 前日、当日、翌日ボタンを押したときの処理
  // 変更日は開始日の入力(startDateInput)に基づきます。
  const previousDateBtn = document.getElementById('previous-date-btn');
  const currentDateBtn = document.getElementById('current-date-btn');
  const nextDateBtn = document.getElementById('next-date-btn');

  if (previousDateBtn && currentDateBtn && nextDateBtn) {
    const startFlatpickr = flatpickr('.flatpickr-datetime-start', flatpickrDatetimeConfig);
    const endFlatpickr = flatpickr('.flatpickr-datetime-end', flatpickrDatetimeConfig);

    const changeDate = (date, dayNum) => {
      const newDate = new Date(date);

      return newDate.setDate(newDate.getDate() + dayNum);
    };

    previousDateBtn.addEventListener('click', (e) => {
      e.preventDefault();

      endFlatpickr.setDate(startFlatpickr.selectedDates[0]);
      startFlatpickr.setDate(changeDate(startFlatpickr.selectedDates[0], -1));
    });

    currentDateBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      startFlatpickr.setDate(today);
      endFlatpickr.setDate(changeDate(today, 1));
    });

    nextDateBtn.addEventListener('click', (e) => {
      e.preventDefault();

      startFlatpickr.setDate(changeDate(startFlatpickr.selectedDates[0], 1));
      endFlatpickr.setDate(changeDate(startFlatpickr.selectedDates[0], 1));
    });
  }
};
